import React from 'react';
import FormField from "./formField"

const EmailFormField = ({
    label,
    name,
    errortext,
    registerfunc,
    errorsfunc,
  }) => (
    <>
      <FormField
        name="email"
        label={`Email *`}
        type="email"
        registerfunc={registerfunc}
        errorsfunc={errorsfunc}
        errortext="Email is required"
      />
    </>
  )

  export default EmailFormField